export default __webpack_public_path__ + "static/festl-brass-preview-003acf55d3d6d8059649e1d1d2595ec2.jpg";